<template>
  <!-- Plantillas 2 a 5: el artículo con el diseño de su portada -->
  <N2DetalleArticulo v-if="Articulo && disenoPropio" :articulo="Articulo" :fecha="date" :relacionados="relatedPosts" />
  <div v-else-if="Articulo" :id="'post-'+Articulo.Id">
    <!-- Start Breadcrump Area  -->
    <div class="rn-page-title-area pt--120 pb--190 banner-blog-details-notin" style="position: relative; z-index: 1; overflow: hidden;">
      <div v-if="img" class="bg_media" :style="{ backgroundImage: img, filter: imgFiltro, WebkitFilter: imgFiltro, position: 'absolute', inset: 0, zIndex: -1, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"></div>
      <v-container style="position: relative; z-index: 2;">
        <v-row>
          <v-col cols="12">
            <div class="banner-blog-details-notin text-center pt--100">
              <h1 class="heading-title">
                {{ Articulo.Titulo }}
              </h1>
              <p v-if="Articulo.Subtitulo">{{ Articulo.Subtitulo }}</p>
              <ul class="blog-meta d-flex justify-center align-center" style="gap: 20px; flex-wrap: wrap;">
                <li class="d-flex align-center">
                  <span class="mr-2 d-flex align-center" v-html="iconSvg('calendar')"></span><span>{{ date }}</span>
                </li>
                <li class="d-flex align-center" v-if="Articulo.Contenido">
                  <span class="mr-2 d-flex align-center" v-html="iconSvg('clock')"></span><span>{{ getReadTime(Articulo.Contenido) }} min de lectura</span>
                </li>
                <li class="d-flex align-center" v-if="Articulo.Autor">
                  <span class="mr-2 d-flex align-center" v-html="iconSvg('user')"></span><span>{{ Articulo.Autor }}</span>
                </li>
                <li class="d-flex align-center" v-if="Articulo.PermitirComentarios">
                  <span class="mr-2 d-flex align-center" v-html="iconSvg('message-circle')"></span><span>{{ Articulo.Comentarios.length }}
                    Comentarios</span>
                </li>
              </ul>
              <div class="mt-4" v-if="Articulo.Categorias && Articulo.Categorias.length > 0">
                 <v-chip variant="outlined" color="white" class="mr-2 text-uppercase" v-for="cat in Articulo.Categorias" :key="cat">
                    {{ cat }}
                 </v-chip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Blog Details Area  -->
    <div class="rn-blog-details pt--110 pb--70 bg_color--1 content-blog-details-notin">
      <v-container>
        <v-row>
          <v-col cols="12" md="10" lg="8" class="mx-auto">
            <!-- Volver -->
            <div class="text-center mb-8 pb-4">
              <NuxtLink to="/blog" class="text-button text-grey-darken-1" style="text-decoration: none; letter-spacing: 1px; text-transform: uppercase;">
                <v-icon size="18" class="mr-1 mb-1">mdi-arrow-left</v-icon> {{ $t('volver') }}
              </NuxtLink>
            </div>

            <div class="content">
              <div v-thtml="Articulo.Contenido">
              </div>
            </div>

            <!-- Encargo online del trámite del que habla el artículo -->
            <SolicitudBlogLlamada :tramite="Articulo.TramiteSolicitud" />

            <!-- Botones Compartir -->
            <div v-if="Articulo.MostrarCompartir !== false" class="share-buttons mt-10 pt-5 text-center" style="border-top: 1px solid #e0e0e0;">
              <h4 class="mb-4">{{ $t('compartir') }}</h4>
              <v-btn icon color="#25D366" class="mr-2 text-white" variant="flat" size="small" :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(Articulo.Titulo + ' ' + pageUrl)}`" target="_blank">
                <v-icon>mdi-whatsapp</v-icon>
              </v-btn>
              <v-btn icon color="#000000" class="mr-2 text-white" variant="flat" size="small" :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(Articulo.Titulo)}`" target="_blank">
                <span style="font-family: sans-serif; font-weight: bold; font-size: 1.1em;">𝕏</span>
              </v-btn>
              <v-btn icon color="#0077B5" class="mr-2 text-white" variant="flat" size="small" :href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`" target="_blank">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn icon color="secondary" variant="flat" size="small" class="text-white" @click="copyLink">
                <v-icon>mdi-link-variant</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <!-- Articulos Relacionados -->
        <v-row v-if="relatedPosts.length > 0" class="mt-16 pt-10" style="border-top: 1px solid #e0e0e0;">
           <v-col cols="12">
             <h3 class="heading-title text-center mb-0">También te puede interesar...</h3>
             <BlogNotinList :customBlogs="relatedPosts" type="blog" :Home="false"></BlogNotinList>
           </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Blog Details Area  -->
    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5 (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2DetalleArticulo from '../../components/notaria2/N2DetalleArticulo.vue'
import { useDisenoPropio } from '../../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { ref, computed, reactive, toRaw, onMounted } from 'vue';
import feather from "feather-icons";
import { useStore } from '../store/index.ts'
import { useRoute, useRouter } from 'vue-router';
import type { SeoPagina } from '../../composables/metaTags'
import { textoPlano, recortar, fechaIso } from '../../composables/useSeoUrls'
const store = useStore()
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
const route = useRoute()
const router = useRouter()
const Articulo = ref(Object)
const date = ref(String)
const pageUrl = ref('')
const snackbar = ref(false)
const snackbarText = ref('')
const formData = reactive({
  name: "",
  email: "",
  subject: "",
  message: "",
})


import { useStyles } from '../../store/styles';
const style = useStyles();
const blog = style.ThemeSectionBlog
// const blogTitulo = ref({
var  blogTitulocolor = blog.Titulo.css.Color;
var  blogTituloshadows = blog.Titulo.css.BackgroundColor ? "4px 2px 6px "+ blog.Titulo.css.BackgroundColor:"";
var  blogTitulofontFamily = blog.Titulo.css.Font;
var  blogTitulosize = blog.Titulo.css.Size;
var  blogTitulofontWeight = blog.Titulo.css.Weight;
var  blogTituloalign = blog.Titulo.css.Align;
// })

// const blogSubtitulo = ref({
var blogSubtitulocolor = blog.Subtitulo.css.Color;
var blogSubtituloshadows = blog.Subtitulo.css.BackgroundColor ? "4px 2px 6px "+ blog.Subtitulo.css.BackgroundColor:"";
var blogSubtitulofontFamily = blog.Subtitulo.css.Font;
var blogSubtitulosize = blog.Subtitulo.css.Size;
var blogSubtitulofontWeight = blog.Subtitulo.css.Weight;
var blogSubtituloalign = blog.Subtitulo.css.Alig;
// })

// const blogButton = ref({
var blogButtoncolor = blog.Button.css.Color
var blogButtonbackgroundColor = blog.Button.css.BackgroundColor
var blogButtonfontFamily = blog.Button.css.Font;
var blogButtonfontWeight = blog.Button.css.Weight;
var blogButtonborder = blog.Button.css.Color??  "2px solid" + blog.Button.css.Color
// })

const imgFiltro = computed(() => blog?.ImagenFiltro ? blog.ImagenFiltro : "")
const img = computed(() => blog.Imagen ? "url(" + imagenIDtoSRC(blog.Imagen)+ ")" : "")

const blogTarjetaFondo = ref("linear-gradient(to bottom," + blog.Tarjeta.FondoCSS.BackgroundColor +" 0,"+ blog.Tarjeta.FondoCSS.BackgroundColorGradient+" 100%)")


var blogDetallesTituloBannercolor= blog.Detalles.TituloBannerCSS.Color
var blogDetallesTituloBannershadows= blog.Detalles.TituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.TituloBannerCSS.BackgroundColor:""
var blogDetallesTituloBannerfontFamily=blog.Detalles.TituloBannerCSS.Font
var blogDetallesTituloBannersize = blog.Detalles.TituloBannerCSS.Size
var blogDetallesTituloBannerfontWeight=blog.Detalles.TituloBannerCSS.Weight
var blogDetallesTituloBanneralign=blog.Detalles.TituloBannerCSS.Align

var blogDetallesSubtituloBannercolor = blog.Detalles.SubtituloBannerCSS.Color
var blogDetallesSubtituloBannershadows = blog.Detalles.SubtituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.SubtituloBannerCSS.BackgroundColor:""
var blogDetallesSubtituloBannerfontFamily = blog.Detalles.SubtituloBannerCSS.Font
var blogDetallesSubtituloBannersize=blog.Detalles.SubtituloBannerCSS.Size
var blogDetallesSubtituloBannerfontWeight = blog.Detalles.SubtituloBannerCSS.Weight
var blogDetallesSubtituloBanneralign = blog.Detalles.SubtituloBannerCSS.Align

var blogDetallesH1color = blog.Detalles.H1.Color
var blogDetallesH1shadows = blog.Detalles.H1.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H1.BackgroundColor:""
var blogDetallesH1fontFamily = blog.Detalles.H1.Font
var blogDetallesH1size =blog.Detalles.H1.Size
var blogDetallesH1fontWeight = blog.Detalles.H1.Weight
var blogDetallesH1align = blog.Detalles.H1.Align

var blogDetallesH2color = blog.Detalles.H2.Color
var blogDetallesH2shadows = blog.Detalles.H2.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H2.BackgroundColor:""
var blogDetallesH2fontFamily = blog.Detalles.H2.Font
var blogDetallesH2size=blog.Detalles.H2.Size
var blogDetallesH2fontWeight=blog.Detalles.H2.Weight
var blogDetallesH2align=blog.Detalles.H2.Align

var blogDetallesH3Acolor = blog.Detalles.H3.Color
var blogDetallesH3Ashadows = blog.Detalles.H3.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H3.BackgroundColor:""
var blogDetallesH3AfontFamily = blog.Detalles.H3.Font
var blogDetallesH3Asize = blog.Detalles.H3.Size
var blogDetallesH3AfontWeight = blog.Detalles.H3.Weight
var blogDetallesH3Aalign = blog.Detalles.H3.Align

var blogDetallesPcolor = blog.Detalles.p.Color
var blogDetallesPshadows = blog.Detalles.p.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.p.BackgroundColor:""
var blogDetallesPfontFamily = blog.Detalles.p.Font
var blogDetallesPsize = blog.Detalles.p.Size
var blogDetallesPfontWeight = blog.Detalles.p.Weight
var blogDetallesPalign = blog.Detalles.p.Align
const blogDetallesFondo = ref("linear-gradient(to bottom," + blog.Detalles.FondoBannerCSS.BackgroundColor +" 0,"+ blog.Detalles.FondoBannerCSS.BackgroundColorGradient+" 100%)")


const parseDateNotin = (dateStr: string) => {
  if (!dateStr) return 0;

  // Try custom parsing first for DD/MM/YYYY format which is ambiguous for new Date()
  if (dateStr.includes('/')) {
     const parts = dateStr.split(/[\s,:/]+/);
     if (parts.length >= 3) {
       // If the first part is 4 digits, it's likely YYYY/MM/DD, let new Date() handle it
       if (parts[0].length !== 4) {
         const day = parseInt(parts[0], 10);
         const month = parseInt(parts[1], 10) - 1;
         const year = parseInt(parts[2], 10);
         const hh = parts[3] ? parseInt(parts[3], 10) : 0;
         const min = parts[4] ? parseInt(parts[4], 10) : 0;
         const sec = parts[5] ? parseInt(parts[5], 10) : 0;
         if(year > 1000 && month >= 0 && month <= 11 && day >= 1 && day <= 31) {
            return new Date(year, month, day, hh, min, sec).getTime();
         }
       }
     }
  }

  const d = new Date(dateStr);
  const t = d.getTime();
  if (!isNaN(t)) return t;

  return 0;
};

const formatDateNotin = (dateStr: string) => {
  const ts = parseDateNotin(dateStr);
  if (!ts) return '';
  return new Date(ts).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
};

const getReadTime = (htmlContent: string) => {
  if (!htmlContent) return 1;
  const text = htmlContent.replace(/<[^>]*>?/gm, '');
  const wpm = 200;
  const words = text.trim().split(/\s+/).length;
  return Math.max(1, Math.ceil(words / wpm));
};

var slug:string = route.params.id.toString()
Articulo.value = store.NOTARIA.Blog.find(x => x.Slug === slug);

onMounted(() => {
  if (typeof window !== 'undefined') {
    pageUrl.value = window.location.href
  }
})

const copyLink = () => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(pageUrl.value).then(() => {
      snackbarText.value = 'Enlace copiado al portapapeles'
      snackbar.value = true
    })
  }
}

const relatedPosts = computed(() => {
  if (!store.NOTARIA || !store.NOTARIA.Blog) return [];
  return store.NOTARIA.Blog
    .filter((p: any) => p.Slug !== slug && p.Publicado)
    .sort((a: any, b: any) => parseDateNotin(b.Fecha) - parseDateNotin(a.Fecha))
    .slice(0, 3);
})

console.log(Articulo.value)
if (!Articulo.value)
  router.push("/404")
else if (!Articulo.value?.Publicado)
  router.push("/404")
else
  date.value = formatDateNotin(Articulo.value.Fecha)

function iconSvg(icon) {
  return feather.icons[icon].toSvg();
}
function onSubmit() {
  ////console.log(this.formData);
}
const PageName = "Blog"
// Cada artículo tiene su propio título, descripción e imagen (si no, todos compartirían los de la sección)
function seoArticulo(): SeoPagina | undefined {
  const a: any = Articulo.value
  if (!a?.Titulo) return undefined
  const imagen = imagenIDtoSRC(a.Imagen)
  return {
    title: a.Titulo,
    description: recortar(textoPlano(a.Extracto || a.Contenido), 155),
    image: imagen.startsWith('http') ? imagen : undefined,
    type: 'article',
    publishedTime: fechaIso(a.Fecha),
    author: a.Autor || undefined,
    nombre: a.Titulo,
    schema: 'BlogPosting'
  }
}
// Slug de este artículo en cada idioma (se traducen), para los hreflang
const slugsSeo = useState<any>('seoSlugs', () => null)
if (!slugsSeo.value) slugsSeo.value = await $fetch(`/_seo/slugs.json?host=${encodeURIComponent(store.host)}`).catch(() => ({}))
function rutasArticulo(): Record<string, string> | undefined {
  const slugs = slugsSeo.value?.blog?.[(Articulo.value as any)?.id]
  return slugs ? Object.fromEntries(Object.entries(slugs).map(([l, s]) => [l, `/blog/${s}`])) : undefined
}
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName,slug,{ ...seoArticulo(), rutasPorIdioma: rutasArticulo() })
</script>


<style lang="scss">
.banner-blog-notin-bg-1{
  background-image:v-bind(img);

}
.banner-blog-notin-filter-1{
  -webkit-backdrop-filter: v-bind(imgFiltro);
  backdrop-filter:v-bind(imgFiltro) ;
}

.banner-blog-notin h1{
  color:v-bind(blogTitulocolor);
  text-shadow:v-bind(blogTituloshadows);
  font-family:v-bind(blogTitulofontFamily);
  font-size:v-bind(blogTitulosize);
  font-weight:v-bind(blogTitulofontWeight);
  text-align:v-bind(blogTituloalign);
}

.banner-blog-notin h2, .banner-blog-notin h3{
  color:v-bind(blogSubtitulocolor);
  text-shadow:v-bind(blogSubtituloshadows);
  font-family:v-bind(blogSubtitulofontFamily);
  font-size:v-bind(blogSubtitulosize);
  font-weight:v-bind(blogSubtitulofontWeight);
  text-align:v-bind(blogSubtituloalign);
}

.banner-blog-notin a, .banner-blog-notin button{
  color:v-bind(blogButtoncolor);
  background-color:v-bind(blogButtonbackgroundColor);
  font-family:v-bind(blogButtonfontFamily);
  font-weight:v-bind(blogButtonfontWeight);
  border:v-bind(blogButtonborder);
}

.banner-blog-details-notin h1, .banner-blog-details-notin h2{
  color:v-bind(blogDetallesTituloBannercolor);
  text-shadow:v-bind(blogDetallesTituloBannershadows);
  font-family:v-bind(blogDetallesTituloBannerfontFamily);
  font-size:v-bind(blogDetallesTituloBannersize);
  font-weight:v-bind(blogDetallesTituloBannerfontWeight);
  text-align:v-bind(blogDetallesTituloBanneralign);
}
.banner-blog-details-notin span{
  color:v-bind(blogDetallesSubtituloBannercolor);
  text-shadow:v-bind(blogDetallesSubtituloBannershadows);
  font-family:v-bind(blogDetallesSubtituloBannerfontFamily);
  // font-size:v-bind(blogDetallesSubtituloBannersize);
  font-weight:v-bind(blogDetallesSubtituloBannerfontWeight);
  text-align:v-bind(blogDetallesSubtituloBanneralign);
}
.content-blog-details-notin h1{
  color:v-bind(blogDetallesH1color);
  text-shadow:v-bind(blogDetallesH1shadows);
  font-family:v-bind(blogDetallesH1fontFamily);
  font-size:v-bind(blogDetallesH1size);
  font-weight:v-bind(blogDetallesH1fontWeight);
  text-align:v-bind(blogDetallesH1align);
}
.content-blog-details-notin h2{
  color:v-bind(blogDetallesH2color);
  text-shadow:v-bind(blogDetallesH2shadows);
  font-family:v-bind(blogDetallesH2fontFamily);
  // font-size:v-bind(blogDetallesH2size);
  font-weight:v-bind(blogDetallesH2fontWeight);
  text-align:v-bind(blogDetallesH2align);
}
.content-blog-details-notin h3 {
  color:v-bind(blogDetallesH3Acolor);
  text-shadow:v-bind(blogDetallesH3Ashadows);
  font-family:v-bind(blogDetallesH3AfontFamily);
  font-size:v-bind(blogDetallesH3Asize);
  font-weight:v-bind(blogDetallesH3AfontWeight);
  text-align:v-bind(blogDetallesH3Aalign);
}
.content-blog-details-notin a {
  color:v-bind(blogDetallesH3Acolor);
  text-shadow:v-bind(blogDetallesH3Ashadows);
  font-weight: bold;
}
.content-blog-details-notin p{
  color:v-bind(blogDetallesPcolor);
  text-shadow:v-bind(blogDetallesPshadows);
  font-family:v-bind(blogDetallesPfontFamily);
  // font-size:v-bind(blogDetallesPsize);
  font-weight:v-bind(blogDetallesPfontWeight);
  text-align:v-bind(blogDetallesPalign);
}
.banner-blog-details-notin{
  background: v-bind(blogDetallesFondo);
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

</style>